class CollapsibleItem extends HTMLElement {
  static get observedAttributes() { return ['open']; }

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);

    this.button = this.querySelector('.collapsible__title');
    this.content = this.querySelector('.collapsible__content');
    if (!this.button || !this.content) return;

    const isOpen = this.hasAttribute('open');
    this.setContentHeight(isOpen);
  }

  connectedCallback() {
    this.button.addEventListener('click', this.toggle);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.toggle);
  }

  toggle() {
    this.hasAttribute('open') ? this.removeAttribute('open') : this.setAttribute('open', '');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setContentHeight(this.hasAttribute('open'));
    }
  }

  setContentHeight(open) {
    this.content.style.height = open ? `${this.content.scrollHeight}px` : '0px';
  }
}

customElements.define('collapsible-item', CollapsibleItem);

class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.hideControlsTimeout = null;
  }

  connectedCallback() {
    // Query elements
    this.video = this.querySelector('.myVideo');
    this.playButton = this.querySelector('.video-text__play-button');
    this.pauseButton = this.querySelector('.video-text__pause-button');
    this.muteButton = this.querySelector('.video-text__mute-button');
    this.unmuteButton = this.querySelector('.video-text__unmute-button');

    // Check if all required elements exist
    if (!this.video || !this.playButton || !this.pauseButton || !this.muteButton || !this.unmuteButton) {
      console.warn('VideoSection: Missing required elements', this);
      return;
    }

    // Initialize event listeners
    this.initialize();
  }

  initialize() {
    // Bind event listeners
    this.playVideo = this.playVideo.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
    this.muteVideo = this.muteVideo.bind(this);
    this.unmuteVideo = this.unmuteVideo.bind(this);
    this.showControls = this.showControls.bind(this);
    this.updateButtonsOnPlay = this.updateButtonsOnPlay.bind(this);
    this.updateButtonsOnPause = this.updateButtonsOnPause.bind(this);

    this.playButton.addEventListener('click', this.playVideo);
    this.pauseButton.addEventListener('click', this.pauseVideo);
    this.muteButton.addEventListener('click', this.muteVideo);
    this.unmuteButton.addEventListener('click', this.unmuteVideo);
    this.addEventListener('mousemove', this.showControls);
    this.video.addEventListener('play', this.updateButtonsOnPlay);
    this.video.addEventListener('pause', this.updateButtonsOnPause);
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.playButton) this.playButton.removeEventListener('click', this.playVideo);
    if (this.pauseButton) this.pauseButton.removeEventListener('click', this.pauseVideo);
    if (this.muteButton) this.muteButton.removeEventListener('click', this.muteVideo);
    if (this.unmuteButton) this.unmuteButton.removeEventListener('click', this.unmuteVideo);
    if (this.video) {
      this.video.removeEventListener('play', this.updateButtonsOnPlay);
      this.video.removeEventListener('pause', this.updateButtonsOnPause);
    }
    this.removeEventListener('mousemove', this.showControls);

    // Clear timeout
    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
      this.hideControlsTimeout = null;
    }
  }

  async playVideo() {
    try {
      await this.video.play();
      this.playButton.style.display = 'none';
      this.pauseButton.style.display = 'flex';
    } catch (error) {
      console.error('VideoSection: Failed to play video', error);
    }
  }

  pauseVideo() {
    this.video.pause();
    this.pauseButton.style.display = 'none';
    this.playButton.style.display = 'flex';
  }

  muteVideo() {
    this.video.muted = true;
    this.muteButton.style.display = 'none';
    this.unmuteButton.style.display = 'flex';
  }

  unmuteVideo() {
    this.video.muted = false;
    this.unmuteButton.style.display = 'none';
    this.muteButton.style.display = 'flex';
  }

  showControls() {
    clearTimeout(this.hideControlsTimeout);
    this.playButton.style.display = this.video.paused ? 'flex' : 'none';
    this.pauseButton.style.display = this.video.paused ? 'none' : 'flex';
    this.muteButton.style.display = this.video.muted ? 'none' : 'flex';
    this.unmuteButton.style.display = this.video.muted ? 'flex' : 'none';

    this.hideControlsTimeout = setTimeout(() => {
      this.playButton.style.display = 'none';
      this.pauseButton.style.display = 'none';
      this.muteButton.style.display = 'none';
      this.unmuteButton.style.display = 'none';
    }, 3000);
  }

  updateButtonsOnPlay() {
    this.playButton.style.display = 'none';
    this.pauseButton.style.display = 'flex';
  }

  updateButtonsOnPause() {
    this.playButton.style.display = 'flex';
    this.pauseButton.style.display = 'none';
  }
}

// Define the custom element
customElements.define('video-section', VideoSection);


const disabledLinks = (urls, attr, setAttr) => {
  [...urls].forEach((url) => {
    url.setAttribute(attr, setAttr);
  });
};

const blockedLinks = (down) => {
  const allLinks = document.querySelectorAll(".url-card");
  down
    ? disabledLinks(allLinks, "disabled", "disabled")
    : disabledLinks(allLinks, "disabled", "");
};

function scrollTouchInit() {
  const sliderTouch = document.querySelectorAll(".scroll-touch");
  window.isDown = false;
  window.blockClose = false;
  let startX;
  let scrollLeft;

  console.log("scrollTouchInit");
  for (let slider of sliderTouch) {
    slider.addEventListener("mousedown", (e) => {
      window.isDown = true;
      setTimeout(() => (window.blockClose = true), 0);
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      window.isDown = false;
      setTimeout(() => (window.blockClose = false), 4000);
      slider.classList.remove("active");
      blockedLinks(window.isDown);
    });
    slider.addEventListener("mouseup", () => {
      window.isDown = false;
      setTimeout(() => (window.blockClose = false), 4000);
      slider.classList.remove("active");
      blockedLinks(window.isDown);
    });
    slider.addEventListener("mousemove", (e) => {
      if (!window.isDown) return;
      e.preventDefault();
      blockedLinks(window.isDown);
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
};


window.addEventListener("load", () => {
  scrollTouchInit();
  console.log("scrollTouchInit");

});



class FAQ extends HTMLElement {
  constructor() {
    super();

    function _s(o, i, p, l) {
      void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
      var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
      window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
          ? ((o.style.height = g * e + "px"),
            (o.style.paddingTop = m * e + "px"),
            (o.style.paddingBottom = h * e + "px"),
            (o.style.marginTop = u * e + "px"),
            (o.style.marginBottom = x * e + "px"))
          : ((o.style.height = s - g * e + "px"),
            (o.style.paddingTop = a - m * e + "px"),
            (o.style.paddingBottom = r - h * e + "px"),
            (o.style.marginTop = y - u * e + "px"),
            (o.style.marginBottom = d - x * e + "px")),
          i <= e
            ? ((o.style.height = ""),
              (o.style.paddingTop = ""),
              (o.style.paddingBottom = ""),
              (o.style.marginTop = ""),
              (o.style.marginBottom = ""),
              (o.style.overflow = ""),
              l || (o.style.display = "none"),
              "function" == typeof p && p())
            : window.requestAnimationFrame(t);
      });
    }
    (HTMLElement.prototype.slideToggle = function (t, e) {
      0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
    }),
      (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
      }),
      (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
      });

    this.initEventListener();
  }
  initEventListener() {
    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener("click", this.toggleFaqItem.bind(this));
    });
  }

  toggleFaqItem(e) {
    e.currentTarget
      .querySelector(".faq-close")
      .classList.toggle("faq-display-none");

    e.currentTarget.closest(".faq-item-container").classList.toggle("actif");

    const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
    console.log(item);

    item.slideToggle("250");
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 300);
  }
}

customElements.define("faq-container", FAQ);


function initJdgm() {
  const widgetHeader = document.querySelector(".jdgm-rev-widg__header");
  let header = document.createElement("div");
  header.classList.add("header-jdgm");

  let header_content = document.createElement("div");
  header_content.classList.add("header__content-jdgm");
  widgetHeader.classList.add("hidden");

  let buttons = document.createElement("div");
  buttons.classList.add("header__buttons-jdgm");

  const summary = document.querySelector(".jdgm-rev-widg__summary");
  const actions = document.querySelector(".jdgm-widget-actions-wrapper");

  if (summary) {
    let rating = document
      .querySelector(".jdgm-rev-widg")
      .getAttribute("data-average-rating");
    buttons.appendChild(summary.cloneNode(true));
    let average_rating = document.createElement("span");
    let average_rating_text = document.createElement("span");
    average_rating_text.classList.add("header__average-rating-jdgm");
    average_rating.classList.add("header__average-rating-jdgm");
    average_rating.textContent = rating;
    average_rating_text.textContent = rating;
    buttons
      .querySelector(".jdgm-rev-widg__summary-stars")
      .appendChild(average_rating);
    document
      .querySelector(".hidden .jdgm-rev-widg__summary-stars")
      .appendChild(average_rating_text);
  } else {
    console.warn("Élément '.jdgm-rev-widg__summary' introuvable");
  }

  if (actions) {
    buttons.appendChild(actions.cloneNode(true));
  } else {
    console.warn("Élément '.jdgm-widget-actions-wrapper' introuvable");
  }

  let histogram = document.createElement("div");
  histogram.classList.add("header__histogram-jdgm");

  const histogram_jdgm = document.querySelector(".jdgm-histogram");

  if (histogram_jdgm) {
    histogram.appendChild(histogram_jdgm.cloneNode(true));
  } else {
    console.warn("Élément '.jdgm-histogram' introuvable");
  }

  let galerie = document.createElement("div");
  galerie.classList.add("header__galery-jdgm");

  const galerie_jdgm = document.querySelector(".jdgm-gallery");

  if (galerie_jdgm) {
    galerie.appendChild(galerie_jdgm.cloneNode(true));
  } else {
    console.warn("Élément '.jdgm-gallery' introuvable");
  }

  let header_title = document.createElement("div");
  header_title.classList.add("header__title-jdgm");
  let header_subtitle = document.createElement("div");
  header_subtitle.classList.add("header__subtitle-jdgm");
  let header_subtitle_2 = document.createElement("div");
  header_subtitle_2.classList.add("header__subtitle-jdgm");
  const title = document.querySelector(".jdgm-rev-widg__title");
  title.innerHTML = 'Vos avis <strong>positifs 🫶</strong>'

  if (title) {
    header_title.appendChild(title.cloneNode(true));
    header_title.appendChild(header_subtitle_2);
    document
      .querySelector(".jdgm-rev-widg__header.hidden")
      .appendChild(header_subtitle);
  } else {
    console.warn("Élément '.jdgm-rev-widg__title' introuvable");
  }

  header_content.appendChild(header_title);
  header_content.appendChild(buttons);
  header_content.appendChild(histogram);
  header_content.appendChild(galerie);

  header.appendChild(header_content);
  let header_container = document.createElement("div");
  header_container.classList.add("jdgm-rev-widg__header");
  header_container.appendChild(header);

  document.querySelector(".jdgm-rev-widg").appendChild(header_container);

  let count = document.createElement("p");
  count.classList.add("jdgm-count-reviews");

  document
    .querySelector(".header-jdgm .jdgm-write-rev-link")
    .addEventListener("click", function (e) {
      e.preventDefault();
      if (
        document
          .querySelector(".hidden .jdgm-form-wrapper")
          .classList.contains("open")
      ) {
        document
          .querySelector(".hidden .jdgm-form-wrapper")
          .classList.remove("open");
      } else {
        document
          .querySelector(".hidden .jdgm-form-wrapper")
          .classList.add("open");
      }
    });

  let couunt_ammount = document
    .querySelector(".jdgm-rev-widg")
    .getAttribute("data-number-of-reviews");

  count.textContent = "Avis Clients (" + couunt_ammount + ")";

  document.querySelector(".jdgm-rev-widg__sort-wrapper").appendChild(count);

  document
    .querySelectorAll(".header-jdgm .jdgm-gallery__thumbnail-wrapper")
    .forEach((elem) => {
      elem.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let image = elem.querySelector("img").getAttribute("data-review-id");
        document
          .querySelector(
            `.hidden .jdgm-gallery__thumbnail[data-review-id="${image}"]`
          )
          .click();
      });
    });

  document
    .querySelectorAll(".header-jdgm .jdgm-histogram__row")
    .forEach((elem) => {
      elem.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let rating = elem.getAttribute("data-rating");
        document
          .querySelector(
            `.hidden .jdgm-histogram__row[data-rating="${rating}"]`
          )
          .click();
      });
    });

  document
    .querySelectorAll(".header__content-jdgm .jdgm-gallery__thumbnail")
    .forEach((elem) => {
      let image = elem.getAttribute("data-src").replace("w=140", "w=600").replace("w=160", "w=600").replace("w=200", "w=600").replace("w=300", "w=600").replace("w=400", "w=600").replace("w=500", "w=600").replace("w=600", "w=600").replace("w=700", "w=600").replace("w=800", "w=600").replace("w=900", "w=600").replace("w=1000", "w=600");
      elem.setAttribute("src", image);
    });
}

function initJdgmAll() {
  // Add stars average ratin
  let rating = document
    .querySelector("[data-average-rating]")
    .getAttribute("data-average-rating");
  let average_rating = document.createElement("span");
  let average_rating_text = document.createElement("span");
  average_rating_text.classList.add("header__average-rating-jdgm");
  average_rating.classList.add("header__average-rating-jdgm");
  average_rating.textContent = rating;
  average_rating_text.textContent = rating;
  document
    .querySelector(".jdgm-all-reviews__summary-stars")
    .prepend(average_rating_text);

  // format total reviews
  const element = document.querySelector(".jdgm-all-reviews__summary-text");
  if (element) {
    let text = element.textContent.trim();
    let match = text.match(/(\d+)\s*(avis)/i);

    if (match) {
      let formattedNumber = parseInt(match[1]).toLocaleString("fr-FR");
      element.innerHTML = text.replace(
        match[0],
        ` <b>${formattedNumber}</b> <b>${match[2]}</b>`
      );
    }

    document
      .querySelectorAll(".jdgm-gallery__thumbnail")
      .forEach((elem) => {
        let image = elem.getAttribute("data-src").replace("w=140", "w=600").replace("w=160", "w=600").replace("w=200", "w=600").replace("w=300", "w=600").replace("w=400", "w=600").replace("w=500", "w=600").replace("w=600", "w=600").replace("w=700", "w=600").replace("w=800", "w=600").replace("w=900", "w=600").replace("w=1000", "w=600");
        elem.setAttribute("src", image);
      });
  }
}

window.addEventListener("load", function () {
  if (document.querySelector(".jdgm-rev-widg__header")) {
    setTimeout(() => {
      initJdgm();
    }
      , 1000);
  }

});

//  add product to cart
function addToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Optionally, you can update the cart UI here
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    // Initialize slides cache BEFORE any updateMedias() call
    const mainWrapper = document.querySelector('.swiper-main .swiper-wrapper');
    const thumbWrapper = document.querySelector('.swiper-thumbs .swiper-wrapper');
    if (mainWrapper && thumbWrapper && !this._allMain) {
      this._allMain = Array.from(mainWrapper.children).map(slide => slide.cloneNode(true));
      this._allThumb = Array.from(thumbWrapper.children).map(slide => slide.cloneNode(true));
    }
    // Now trigger the initial variant change
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // Track if variant options changed (not just the product/pack)
    const currentOptions = [
      this.currentVariant.option1,
      this.currentVariant.option2,
      this.currentVariant.option3
    ].filter(Boolean).join('-');

    const variantOptionsChanged = this.lastVariantOptions !== currentOptions;
    this.lastVariantOptions = currentOptions;

    //  for fieldset in variant select if color-label in fieldset then set the color-label to the color of the variant
    const fieldsets = this.querySelectorAll('fieldset');
    fieldsets.forEach((fieldset) => {
      const colorLabel = fieldset.querySelector('.color-label');
      if (colorLabel) {
        colorLabel.textContent = ' ' + this.currentVariant.options[1];
      }
    });

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        let currentProducts = document.querySelectorAll('.product-pack');

        let currentProduct = Array.from(currentProducts).find(product => product.classList.contains('active'));
        if (currentProduct) {
          const activePackProductId = currentProduct.getAttribute('data-product-id');

          // Determine which bundle the active pack belongs to
          const activePackBundle = productBundle.some(v => String(v.product_id) === String(activePackProductId)) ? productBundle : productBundle_2;

          // Find the corresponding variant in the active pack's bundle
          const variantForActivePack = activePackBundle.find(v => v.title === this.currentVariant.title);

          if (variantForActivePack) {
            const fakeComparePrice = parseFloat(variantForActivePack.price) + 50;
            currentProduct.querySelector('.product-pack__price s').textContent = fakeComparePrice.toFixed(2).replace('.', ',') + '€';
            currentProduct.querySelector('.product-pack__current-price').textContent = variantForActivePack.price.replace('.', ',') + '€';
            currentProduct.querySelector('.current-unit-price').textContent = variantForActivePack.unit_price ? variantForActivePack.unit_price.replace('.', ',') + '€' : '0,00€';

            // Update submit price with the variant from the active pack
            const submitPrice = document.querySelector(`.product-form__submit-price`);
            if (submitPrice) {
              const comparedPriceElement = submitPrice.querySelector('[data-compared-price]');
              const currentPriceElement = submitPrice.querySelector('[data-current-price]');

              if (comparedPriceElement) {
                const fakeComparePriceSubmit = parseFloat(variantForActivePack.price) + 50;
                comparedPriceElement.textContent = fakeComparePriceSubmit.toFixed(2).replace('.', ',') + '€';
              }
              if (currentPriceElement) {
                currentPriceElement.textContent = variantForActivePack.price.replace('.', ',') + '€';
              }
            }

            let reduction = document.querySelector('[data-current-reduction]').getAttribute('data-current-reduction');
            if (document.querySelector('.product-form__third-step--buttons [data-current-price-reduc')) {
              document.querySelector('.product-form__third-step--buttons [data-current-price-reduc]').textContent = (parseFloat(variantForActivePack.price) - parseInt(reduction)).toFixed(2).replace('.', ',') + '€';
              document.querySelector('.product-form__third-step--buttons [data-current-price]').textContent = variantForActivePack.price.replace('.', ',') + '€';
            }
          }

          document.querySelector(`[data-current-variant-id]`).setAttribute('data-current-variant-id', this.currentVariant.id);

          if (this.currentVariant && this.currentVariant.id) {
            // Update non-active product pack
            const nonActiveProduct = document.querySelector('.product-pack:not(.active)');
            if (nonActiveProduct) {
              const nonActivePackProductId = nonActiveProduct.getAttribute('data-product-id');

              // Determine which bundle the non-active pack belongs to
              const nonActivePackBundle = productBundle.some(v => String(v.product_id) === String(nonActivePackProductId)) ? productBundle : productBundle_2;

              // Find the corresponding variant in the non-active pack's bundle
              const variantForNonActivePack = nonActivePackBundle.find(v => v.title === this.currentVariant.title);

              if (variantForNonActivePack) {
                const fakeComparePriceOther = parseFloat(variantForNonActivePack.price) + 50;
                nonActiveProduct.querySelector('.product-pack__price s').textContent = fakeComparePriceOther.toFixed(2).replace('.', ',') + '€';
                nonActiveProduct.querySelector('.product-pack__current-price').textContent = variantForNonActivePack.price.replace('.', ',') + '€';
                nonActiveProduct.querySelector('.current-unit-price').textContent = variantForNonActivePack.unit_price ? variantForNonActivePack.unit_price.replace('.', ',') + '€' : '0,00€';
              } else {
                console.log('No matching variant found for non-active pack');
              }
            } else {
              console.log('No non-active product pack found');
            }
          } else {
            console.log('Current variant or variant ID is undefined');
          }
        }
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price - ${this.dataset.section} `);
        const source = html.getElementById(`price - ${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} `);
        const skuSource = html.getElementById(`Sku - ${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} `);
        const skuDestination = document.getElementById(`Sku - ${this.dataset.section} `);
        const inventorySource = html.getElementById(`Inventory - ${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} `);
        const inventoryDestination = document.getElementById(`Inventory - ${this.dataset.section} `);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price - ${this.dataset.section} `);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        console.log(this.currentVariant);
      });

   // Only update media if variant options changed (matière, couleur, taille)
   // Don't update when just switching between packs (3 taies ↔ 7 taies)
   if (variantOptionsChanged) {
     this.updateMedias();
   }
    

    
  }

  updateMedias() {
    const name = [
      this.currentVariant.option1,
      this.currentVariant.option2,
      this.currentVariant.option3
    ].filter(option => option).join(' - '); // Filter out null/undefined options


    const mainWrapper = document.querySelector('.swiper-main .swiper-wrapper');
    const thumbWrapper = document.querySelector('.swiper-thumbs .swiper-wrapper');

    // Cache should already be initialized in connectedCallback()
    if (!this._allMain || !this._allThumb) {
      return;
    }

    // Clear wrappers without losing references
    while (mainWrapper.firstChild) {
      mainWrapper.removeChild(mainWrapper.firstChild);
    }
    while (thumbWrapper.firstChild) {
      thumbWrapper.removeChild(thumbWrapper.firstChild);
    }

    // Append only slides matching the current variant (matière + couleur + taille)
    // Images are shared between 3 taies and 7 taies products
    this._allMain.forEach(slide => {
      if (slide.dataset.mediaVariant === name) {
        mainWrapper.appendChild(slide.cloneNode(true));
      }
    });

    this._allThumb.forEach(slide => {
      if (slide.dataset.mediaVariant === name) {
        thumbWrapper.appendChild(slide.cloneNode(true));
      }
    });

    // Refresh Swiper to update the carousel
    if (document.querySelector('product-template').refreshMedias) {
      document.querySelector('product-template').refreshMedias();
    }
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product - form - ${this.dataset.section} `);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    document.querySelector('.variant_picker--product:not(.hidden) [data-option-position="2"] input:not(.disabled) + label').click();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }

      //  in [data-option-position="2"] find input not disabled and click on it 
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked) ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function setStarRating(rating, elem) {
      // Ensure rating is between 1 and 5
      rating = Math.max(1, Math.min(5, rating));
      
      // Get all star paths
      const stars = [
        elem.getElementById('star1'),
        elem.getElementById('star2'),
        elem.getElementById('star3'),
        elem.getElementById('star4'),
        elem.getElementById('star5')
      ];

      // Calculate full and partial stars
      const fullStars = Math.floor(rating);
      const partialStar = rating % 1 !== 0 ? Math.round((rating % 1) * 10) / 10 : 0;

      // Update star colors
      stars.forEach((star, index) => {
        if (index < fullStars) {
          // Full orange star
          star.setAttribute('fill', '#EF6F2D');
        } else if (index === fullStars && partialStar > 0) {
          // Partial star with gradient
          star.setAttribute('fill', `url(#half-fill-${index + 1})`);
          // Update gradient stop offset for partial star
          const gradient = document.getElementById(`half-fill-${index + 1}`);
          gradient.children[0].setAttribute('offset', `${partialStar * 100}%`);
          gradient.children[1].setAttribute('offset', `${partialStar * 100}%`);
        } else {
          // Gray star
          star.setAttribute('fill', '#CCCCCC');
        }
      });
    }



  document.querySelectorAll('.product-form__judgeme svg').forEach((elem) => {
   setStarRating(Number(document.querySelector('[data-product-review-note]').getAttribute('data-product-review-note')) , elem);
  });


(function(){
  function scrollToAnchor(hash) {
    const target = document.querySelector(hash);
    if (!target) return;
    // Scroll via scrollIntoView pour bénéficier de scroll-margin-top
    target.scrollIntoView({ behavior: 'smooth' });
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const hash = this.getAttribute('href');
      scrollToAnchor(hash);
      window.addEventListener('load', () => scrollToAnchor(hash), { once: true });
      setTimeout(() => scrollToAnchor(hash), 300);
      setTimeout(() => scrollToAnchor(hash), 600);
      setTimeout(() => scrollToAnchor(hash), 900);
    });
  });
})();